module.exports = new __parcel__URL__("empty.565fbc78.svg").toString();